// The load-only-on-origin invariant.
//
// A mirrored in-person event shares the ORIGIN (international) site session
// rows/counts — one physical room, one set of seats — which is correct ONLY
// because a mirrored event single page is reachable exclusively on the
// international domain. Mirrored cards on a country listing therefore link to an
// ABSOLUTE international-domain URL, so clicking one is a cross-domain navigation
// to intl and the page loads under the origin x-site-id.
//
// If a mirrored card ever produced a relative or country-domain URL, the single
// page would load under a COUNTRY x-site-id, find 0 session rows, fall back to the
// legacy per-site counts, and the shared physical room would be silently
// double-booked. This helper is the single source of the mirrored-card URL so the
// regression test in __test__/build-mirrored-event-url.test.ts locks the invariant.
//
// Kept dependency-free (structural param type, no imports) so it is trivially
// unit-testable under the jest/ts-jest tsconfig.

type IntlSiteDomain = { domains: { [key: string]: string } } | undefined;

export const buildMirroredEventUrl = (
    internationalSite: IntlSiteDomain,
    target: string,
    protocol: string | undefined,
    eventUrl: string,
): string => {
    const intlBaseUrl = internationalSite?.domains[target];
    return protocol + '://' + intlBaseUrl + '/' + eventUrl;
};
